import React from "react";
import ChatMenuItem from "./ChatMenuItem";
import { classNames } from "../../../../../helpers/classNames";
import { t } from "i18next";

const RecentChats = ({
  selectChatHandler,
  chatList = [],
  activeChatId,
  onChatListLoad = () => {},
}) => {
  return (
    <>
      <div className="mt-3 text-base font-medium leading-tight intro-y">
        {t("Recent Chats")}
      </div>
      <div className="px-5 pt-2 pr-2 mt-3 -mx-5 h-full overflow-y-auto intro-y scrollbar-hidden">
        {chatList?.length > 0 && (
          <div
            className="space-y-2 chat-list !h-[calc(100vh-320px)] overflow-y-auto pr-3"
            onScroll={onChatListLoad}
          >
            {chatList?.map((item, i) => (
              <ChatMenuItem
                key={i?.toString()}
                chat={item}
                selectChatHandler={() => selectChatHandler(item)}
                activeChatId={activeChatId}
              />
            ))}
          </div>
        )}
        {chatList?.length === 0 && (
          <div className="flex flex-col items-center justify-center h-full space-y-1">
            {Array.from({ length: 2 }, (_, i) => (
              <div
                key={i?.toString()}
                className={classNames(
                  "flex w-full gap-2",
                  i === 1 ? "opacity-60" : ""
                )}
              >
                <div className="w-14 h-14 bg-gray-200 rounded-full"></div>
                <div className="flex-grow flex justify-center gap-y-2 flex-col">
                  <div className="bg-gray-200 h-4 rounded-md w-full"></div>
                  <div className="bg-gray-200 h-4 rounded-md w-2/3"></div>
                </div>
              </div>
            ))}
            <div className="pt-4 space-y-2">
              <div className="text-center font-semibold text-lg text-deep-purple">
                Your inbox is empty
              </div>
              <div className="text-center text-xs text-gray-400 font-medium">
                Once you start a new conversation, you'll see it listed here
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default RecentChats;
